export const SIDEBAR_EXPANDED_WIDTH = "280px";
export const SIDEBAR_COLLAPSED_WIDTH = "92px";
